const queryString = require('query-string');

export function loadRentalRateCoupons(systemId, query) {
  return {
    type: "FETCH_RENTAL_RATE_COUPONS",
    payload: {
      request: {
        method: 'get',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons?` + queryString.stringify(query)
      },
      query: query,
      globalLoading: false
    }
  };
}

export function createRentalRateCoupon(systemId, data) {
  return {
    type: "CREATE_RENTAL_RATE_COUPON",
    payload: {
      request: {
        method: 'post',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons`,
        data: data
      },
      globalLoading: true,
      successCallback: (response) => {
        return {
          type: 'REDIRECT_TO',
          payload: `/system/${systemId}/rental-rate-coupon/${response.data.id}`
        }
      }
    }
  };
}

export function fetchRentalRateCoupon(systemId, couponId) {
  return {
    type: "FETCH_RENTAL_RATE_COUPON",
    payload: {
      request: {
        method: 'get',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons/${couponId}`
      },
      globalLoading: true
    }
  };
}

export function updateRentalRateCoupon(systemId, couponId, data) {
  return {
    type: "UPDATE_RENTAL_RATE_COUPON",
    payload: {
      request: {
        method: 'put',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons/${couponId}`,
        data: data
      },
      successAction: {
        type: 'SHOW_NOTIFICATION',
        payload: {
          variant: 'success',
          message: 'notifications.update_rental_rate_coupon_success_message'
        }
      },
      redirect: `/system/${systemId}/rental-rate-coupon/${couponId}`,
      globalLoading: true
    }
  };
}

export function updateRentalRateCouponStatus(systemId, couponId, data) {
  return {
    type: "UPDATE_RENTAL_RATE_COUPON",
    payload: {
      request: {
        method: 'put',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons/${couponId}/status`,
        data: data
      },
      successAction: {
        type: 'SHOW_NOTIFICATION',
        payload: {
          variant: 'success',
          message: 'notifications.update_rental_rate_coupon_success_message'
        }
      },
      globalLoading: true
    }
  };
}

export function deleteRentalRateCoupon(systemId, couponId) {
  return {
    type: "DELETE_RENTAL_RATE_COUPON",
    payload: {
      request: {
        method: 'delete',
        url: `/api/v1/bo/${systemId}/rental-rate-coupons/${couponId}`
      },
      successAction: {
        type: 'SHOW_NOTIFICATION',
        payload: {
          variant: 'success',
          message: 'notifications.delete_rental_rate_coupon_success_message'
        }
      },
      redirect: `/system/${systemId}/rental-rates/coupons`,
      globalLoading: true
    }
  };
}
